<template>
    <div class="web-home-copyright">
        <div class="web-home-copyright-content">
            <p>©2022 木火通明  <a  class="link" href="https://beian.miit.gov.cn/" target="_blank">ICP备19151551号</a></p>
        </div>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config'
export default {
    name: 'WebCopyRight',
    methods: {
        clickLink() {
            window.open(CONFIG.icp_url);
        }
    }
}
</script>